import {SET_LANG} from "pointant/store/actionTypes"
export const setLanguage = language =>{
  window.localStorage.setItem("appUILanguageCode",language)
  return {
    type: SET_LANG,
    language
  }
}